/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Autocomplete,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import moment from 'moment';
import useProductSamplingInventoryContext from '../context/useProductSamplingInventoryContext';

export default function UpdateProductModal() {
  const {
    updateProductModal,
    setUpdateProductModal,
    productOptions,
    specialtyOptions,
    handleUpdateProduct,
  } = useContext(useProductSamplingInventoryContext);

  const handleChangeDropdown = (newValue, row, index, name) => {
    const newArr = [...updateProductModal.products];

    if (name === 'product') {
      newArr[index] = {
        id: row.id,
        product_code: newValue?.value,
        product_name: newValue?.label,
        specialty: newArr[index]?.specialty,
        qty: newArr[index]?.qty,
        product_selected: newValue,
        specialty_selected: newArr[index]?.specialty_selected,
      };
    }

    if (name === 'specialty') {
      newArr[index] = {
        id: row.id,
        product_code: newArr[index]?.product_code,
        product_name: newArr[index]?.product_name,
        specialty: newValue?.value,
        qty: newArr[index]?.qty,
        product_selected: newArr[index]?.product_selected,
        specialty_selected: newValue,
      };
    }

    if (name === 'quantity') {
      newArr[index] = {
        id: row.id,
        product_code: newArr[index]?.product_code,
        product_name: newArr[index]?.product_name,
        specialty: newArr[index]?.specialty,
        qty: newValue.target.value,
        product_selected: newArr[index]?.product_selected,
        specialty_selected: newArr[index]?.specialty_selected,
      };
    }

    setUpdateProductModal({ ...updateProductModal, products: newArr });
  };

  const columns = [
    {
      field: 'specialty_selected',
      headerName: 'MD Specialty',
      width: 400,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='specialty_selected'
            disableClearable
            options={specialtyOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} />}
            value={params?.row?.specialty_selected}
            onChange={(e, newValue) =>
              handleChangeDropdown(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'specialty',
              )
            }
            sx={{ backgroundColor: '#fff', width: '460%' }}
            required
          />
        </div>
      ),
    },
    {
      field: 'product_selected',
      headerName: 'Product Name',
      width: 400,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='product_selected'
            disableClearable
            options={productOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} />}
            value={params?.row?.product_selected}
            onChange={(e, newValue) =>
              handleChangeDropdown(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
                'product',
              )
            }
            sx={{ backgroundColor: '#fff', width: '460%' }}
            required
          />
        </div>
      ),
    },
    {
      field: 'qty',
      headerName: 'Quantity',
      width: 300,
      renderCell: (params) => (
        <div>
          <TextField
            id='filled-number'
            type='number'
            value={params?.row?.qty}
            sx={{
              backgroundColor: '#fff',
              width: '165%',
              'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              'input[type=number]': {
                MozAppearance: 'textfield',
              },
            }}
            slotProps={{
              inputLabel: {
                shrink: true,
              },
            }}
            onChange={(e, newValue) =>
              handleChangeDropdown(e, params.row, params.api.getRowIndex(params.row.id), 'quantity')
            }
          />
        </div>
      ),
    },
  ];

  const handleClose = () => {
    setUpdateProductModal({
      ...updateProductModal,
      toggle: false,
      date: moment().format('YYYY-MM'),
      products: [],
    });
  };

  const handleChangeDate = (value) => {
    setUpdateProductModal({ ...updateProductModal, date: moment(value).format('YYYY-MM') });
  };
  return (
    <Dialog onClose={handleClose} open={updateProductModal.toggle} fullWidth maxWidth='lg'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Update Product
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid xs={3} sm={3} md={3}>
            <DatePicker
              label='date'
              views={['month', 'year']}
              value={updateProductModal?.date}
              // eslint-disable-next-line react/jsx-props-no-spreading
              /* eslint-disable react/jsx-props-no-spreading */
              renderInput={(params) => (
                <TextField {...params} label='Date' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate(value)}
            />
          </Grid>
          <Grid xs={9} sm={9} md={9} />
        </Grid>

        <Grid xs={12} sm={12} md={12}>
          <div className='table-container' style={{ height: '500px', marginTop: '20px' }}>
            <DataGridPro
              rows={updateProductModal?.products}
              columns={columns}
              getRowHeight={() => 'auto'}
              sx={{
                '& .MuiDataGrid-cell': {
                  padding: 0,
                },
              }}
            />
          </div>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={handleUpdateProduct}>
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
